<form [formGroup]="createProfile" (ngSubmit)="save()">
  <div class="header-wrapper">
    <h1>Edit Profile</h1>

    <button
      class="mt-25 w-100 h-56 bck-color-blue"
      style="text-align: center; width: 202px"
      mat-raised-button
      type="submit"
      [disabled]="isFormDisabled"
      [ngClass]="{ 'bck-color-blue': !isFormDisabled, 'bck-color-grey': isFormDisabled }"
    >
      <ng-container
        *ngIf="!loading && !isSubmitLoading; else loadingContent"
      >
        <img
          style="margin-right: 8px"
          *ngIf="!isFormDisabled"
          class="icon"
          src="assets/icons/check_circle_white.svg"
          alt="Save Changes"
          width="24"
          height="24"
        />
        <svg
          *ngIf="isFormDisabled"
          style="margin-right: 8px"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            #active
            d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6
                          11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10
                          20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333
                          18.6873 3.825 17.975 2.925 17.075C2.025 16.175
                          1.31267 15.1167 0.788 13.9C0.262667 12.6833 0
                          11.3833 0 10C0 8.61667 0.262667 7.31667 0.788
                          6.1C1.31267 4.88333 2.025 3.825 2.925
                          2.925C3.825 2.025 4.88333 1.31233 6.1
                          0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0
                          12.6833 0.262333 13.9 0.787C15.1167 1.31233
                          16.175 2.025 17.075 2.925C17.975 3.825 18.6873
                          4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20
                          10C20 11.3833 19.7373 12.6833 19.212
                          13.9C18.6873 15.1167 17.975 16.175 17.075
                          17.075C16.175 17.975 15.1167 18.6873 13.9
                          19.212C12.6833 19.7373 11.3833 20 10 20ZM10
                          18C12.2333 18 14.125 17.225 15.675 15.675C17.225
                          14.125 18 12.2333 18 10C18 7.76667 17.225 5.875
                          15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667
                          2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667
                          2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875
                          17.225 7.76667 18 10 18Z"
            fill="#00000042"
          />
        </svg>

        <span class="button-save-font">Save Changes</span>
      </ng-container>
      <ng-template #loadingContent>
        <!-- <span *ngIf="!loading && !isSubmitLoading" style="color: brown;">Save changes111</span> -->
        <div class="spinner">
          <div>
            <mat-spinner
              *ngIf="loading && isSubmitLoading"
              diameter="20"
              color="#1E31CF"
            ></mat-spinner>
          </div>
        </div>
      </ng-template>
    </button>

    <button
      *ngIf="false"
      class="mt-25 w-100 h-56 bck-color-blue"
      style="text-align: center; width: 202px"
      mat-raised-button
      color="yellow"
      type="submit"
      [disabled]="
        createProfile.invalid ||
        createProfile.pristine ||
        formSubmitted ||
        (createProfile.get('vatIncluded')?.touched &&
          createProfile.get('vatIncluded')?.value ===
            originalVatIncludedValue)
      "
      [ngClass]="{ 'bck-color-grey': loading }"
    >
      <!-- svg ispod je tamna crna disabled -->
      <div *ngIf="false">
        <svg
          *ngIf="
            (!loading &&
              (createProfile.invalid || !createProfile.dirty)) ||
            formSubmitted ||
            (createProfile.get('vatIncluded')?.touched &&
              createProfile.get('vatIncluded')?.value ===
                originalVatIncludedValue)
          "
          style="margin-right: 8px"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            #active
            d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6
                          11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10
                          20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333
                          18.6873 3.825 17.975 2.925 17.075C2.025 16.175
                          1.31267 15.1167 0.788 13.9C0.262667 12.6833 0
                          11.3833 0 10C0 8.61667 0.262667 7.31667 0.788
                          6.1C1.31267 4.88333 2.025 3.825 2.925
                          2.925C3.825 2.025 4.88333 1.31233 6.1
                          0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0
                          12.6833 0.262333 13.9 0.787C15.1167 1.31233
                          16.175 2.025 17.075 2.925C17.975 3.825 18.6873
                          4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20
                          10C20 11.3833 19.7373 12.6833 19.212
                          13.9C18.6873 15.1167 17.975 16.175 17.075
                          17.075C16.175 17.975 15.1167 18.6873 13.9
                          19.212C12.6833 19.7373 11.3833 20 10 20ZM10
                          18C12.2333 18 14.125 17.225 15.675 15.675C17.225
                          14.125 18 12.2333 18 10C18 7.76667 17.225 5.875
                          15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667
                          2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667
                          2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875
                          17.225 7.76667 18 10 18Z"
            fill="#00000042"
          />
        </svg>
      </div>

      <!-- *ngIf="
          !loading &&
          !createProfile.invalid &&
          createProfile.dirty && (createProfile.get('vatIncluded')?.touched && createProfile.get('vatIncluded')?.value !== originalVatIncludedValue && createProfile.get('vatIncluded')?.touched)
        " -->

      <!-- ova ispod je bijela ikonica -->
      <svg
        *ngIf="!loading"
        style="margin-right: 8px"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6
                          11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10
                          20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333
                          18.6873 3.825 17.975 2.925 17.075C2.025 16.175
                          1.31267 15.1167 0.788 13.9C0.262667 12.6833 0
                          11.3833 0 10C0 8.61667 0.262667 7.31667 0.788
                          6.1C1.31267 4.88333 2.025 3.825 2.925
                          2.925C3.825 2.025 4.88333 1.31233 6.1
                          0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0
                          12.6833 0.262333 13.9 0.787C15.1167 1.31233
                          16.175 2.025 17.075 2.925C17.975 3.825 18.6873
                          4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20
                          10C20 11.3833 19.7373 12.6833 19.212
                          13.9C18.6873 15.1167 17.975 16.175 17.075
                          17.075C16.175 17.975 15.1167 18.6873 13.9
                          19.212C12.6833 19.7373 11.3833 20 10 20ZM10
                          18C12.2333 18 14.125 17.225 15.675 15.675C17.225
                          14.125 18 12.2333 18 10C18 7.76667 17.225 5.875
                          15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667
                          2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667
                          2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875
                          17.225 7.76667 18 10 18Z"
          fill="white"
        />
      </svg>

      <span *ngIf="!loading && !isSubmitLoading">Save changes</span>
      <div class="spinner">
        <div>
          <mat-spinner
            *ngIf="loading && isSubmitLoading"
            diameter="20"
            color="#1E31CF"
          ></mat-spinner>
        </div>
      </div>
    </button>
  </div>
  <div *ngIf="!loading" class="container-fluid">
    <div class="row mb-20">
      <div class="col-12 col-sm-6 col-lg-4">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Name</mat-label>
          <input
            formControlName="firstName"
            type="text"
            required="true"
            maxlength="30"
            matInput
            (input)="onNameChange($event)"
            (keyup)="inputChanged($event)"
            [style.color]="createProfile.get('firstName')?.invalid && (createProfile.get('firstName')?.dirty && createProfile.get('firstName')?.touched) ? 'rgba(204, 0, 0, 1)!important' : ''"
          />
          <!-- <mat-error
            *ngFor="let validation of account_validation_messages.username"
          >
            <mat-error
              class="error-message"
              *ngIf="
                createProfile.get('name')?.hasError(validation.type) &&
                (createProfile.get('name')?.dirty &&
                  createProfile.get('name')?.touched)
              "
              >{{ validation.message }}</mat-error
            >
          </mat-error> -->
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-6 col-lg-4">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Surname</mat-label>
          <input
            formControlName="lastName"
            type="text"
            matInput
            maxlength="30"
            (input)="onSurnameChange($event)"
            (keyup)="inputChanged($event)"
            [style.color]="createProfile.get('lastName')?.invalid && (createProfile.get('lastName')?.dirty && createProfile.get('lastName')?.touched) ? 'rgba(204, 0, 0, 1)!important' : ''"
          />
          <mat-error
            *ngFor="let validation of account_validation_messages.username"
          >
            <mat-error
              class="error-message"
              *ngIf="
                createProfile.get('name')?.hasError(validation.type) &&
                (createProfile.get('name')?.dirty &&
                  createProfile.get('name')?.touched)
              "
              >{{ validation.message }}</mat-error
            >
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-20">
      <div class="col-12 col-sm-6 col-lg-4">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Phone</mat-label>
          <input
          formControlName="phone"
          maxlength="13"
          minlength="9"
          matInput
          placeholder="Phone"
        
          (keyup)="inputChanged($event)"
          (input)="onInputChange($event)"
          [style.color]="createProfile.get('phone')?.invalid && (createProfile.get('phone')?.dirty && createProfile.get('phone')?.touched) ? 'rgba(204, 0, 0, 1)!important' : ''"
        />
          <!-- <mat-error
            *ngFor="let validation of account_validation_messages.phone"
          >
            <mat-error
              class="error-message"
              *ngIf="
                createProfile.get('phone')?.hasError(validation.type) &&
                (createProfile.get('phone')?.dirty &&
                  createProfile.get('phone')?.touched)
              "
            ></mat-error>
          </mat-error> -->
        </mat-form-field>
      </div>

      <div class="col-12 col-sm-6 col-lg-4">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Email</mat-label>
          <input
            formControlName="email"
            type="email"
            matInput
            [attr.disabled]="true"
            placeholder=""
            [style.color]="createProfile.get('email')?.invalid && (createProfile.get('email')?.dirty && createProfile.get('email')?.touched) ? 'rgba(204, 0, 0, 1)!important' : ''"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-20">
      <div class="col-12 col-sm-6 col-lg-4">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Company</mat-label>
          <input
            formControlName="company"
            type="text"
            matInput
            maxlength="50"
            placeholder=""
            (keyup)="inputChanged($event)"
            [style.color]="createProfile.get('company')?.invalid && (createProfile.get('company')?.dirty && createProfile.get('company')?.touched) ? 'rgba(204, 0, 0, 1)!important' : ''"
          />
          <mat-error
            *ngFor="let validation of account_validation_messages.company"
          >
            <mat-error
              class="error-message"
              *ngIf="
                createProfile.get('company')?.hasError(validation.type) &&
                (createProfile.get('company')?.dirty &&
                  createProfile.get('company')?.touched)
              "
            ></mat-error>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- test start -->

    <div class="row">

      <div class="col-12 col-sm-6 col-lg-4">
      </div>
      <div class="col-12 col-sm-6 col-lg-4" style="display: flex;justify-content: flex-end">
        <mat-slide-toggle
          formControlName="vatIncluded"
          labelPosition="before"
          name="vatIncluded"
          (change)="onVatIncludedToggle()"
        >
         <span class="vat-included-font">VAT Included</span>
        </mat-slide-toggle>
      </div>

    </div>
    <div class="row mb-80">
      <div class="col-12 col-sm-6 col-lg-4">
        <div
          class="error-message-block"
          *ngIf="
            createProfile.get('company')?.hasError('required') ||
            createProfile.get('firstName')?.hasError('required') ||
            createProfile.get('lastName')?.hasError('required') ||
            createProfile.get('phone')?.hasError('required')
          "
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 15C10.2833 15 10.521 14.904 10.713 14.712C10.9043 14.5207 11 14.2833 11 14C11 13.7167 10.9043 13.479 10.713 13.287C10.521 13.0957 10.2833 13 10 13C9.71667 13 9.47933 13.0957 9.288 13.287C9.096 13.479 9 13.7167 9 14C9 14.2833 9.096 14.5207 9.288 14.712C9.47933 14.904 9.71667 15 10 15ZM9 11H11V5H9V11ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
              fill="#870004"
            />
          </svg>
          <span class="field-required-font">Each field is required</span>
        </div>

      </div>

    </div>

    <!-- test end -->

    <!-- <div class="col-12 col-sm-6">
      <mat-slide-toggle
        [(ngModel)]="vatIncluded"
        labelPosition="before"
        name="vatIncluded"
      >
        VAT Included
      </mat-slide-toggle>
    </div> -->
    <div class="row mb-20" (click)="setUsernameToReadOnlyFalse()">
      <div class="col-12 col-sm-6 col-lg-4">
        <h3 class="secondary-label">Change Password</h3>
        <mat-form-field class="mt-40" appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Password</mat-label>
          <input
            formControlName="oldpassword"
            autocomplete="off"
            class="wide-input"
            [type]="hide1 ? 'text' : 'password'"
            matInput
            placeholder=""
            name="oldpassword"
            (keyup)="inputChanged($event)"
            [readonly]="isUsernameReadOnly"
            [style.color]="createProfile.get('oldpassword')?.invalid && (createProfile.get('oldpassword')?.dirty && createProfile.get('oldpassword')?.touched) ? 'rgba(204, 0, 0, 1)!important' : ''"
            (input)="errorMessage = ''"
          />
          <!-- <mat-error *ngIf="createProfile.hasError('mismatch', ['newpassword', 'confirm'])">
            New password and confirm password must match.
          </mat-error> -->

          <!-- <mat-error
          *ngFor="let validation of account_validation_messages.username"
        >
          <mat-error
            class="error-message"
            *ngIf="
              createProfile.get('name')?.hasError(validation.type) &&
              (createProfile.get('name')?.dirty &&
                createProfile.get('name')?.touched)
            "
            >{{ validation.message }}</mat-error
          >
        </mat-error> -->

          <button
            matSuffix
            (click)="hide1 = !hide1"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide1"
            type="button"
            mat-icon-button
          >
            <svg
              *ngIf="!hide1"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0862 13.328C10.3725 13.4404 10.6812 13.5 11 13.5C12.3807 13.5 13.5 12.3807 13.5 11C13.5 10.6812 13.4404 10.3725 13.328 10.0862L10.0862 13.328ZM14.81 8.60425C15.2551 9.31096 15.5 10.1367 15.5 11C15.5 13.4853 13.4853 15.5 11 15.5C10.1367 15.5 9.31096 15.2551 8.60425 14.81L6.60263 16.8116C7.98547 17.5773 9.48878 18 11 18C15.4476 18 20 13.9121 20 11C20 9.7008 18.8434 7.80659 17.0764 6.33781L14.81 8.60425ZM18.496 4.91819C20.6046 6.71959 22 9.0733 22 11C22 15.0675 16.5071 20 11 20C8.94776 20 6.93674 19.3774 5.14077 18.2734L2.51472 20.8995C2.12419 21.29 1.49103 21.29 1.10051 20.8995C0.709981 20.509 0.709981 19.8758 1.10051 19.4853L4.29174 16.2941C4.30004 16.2855 4.30847 16.277 4.31702 16.2688L16.2704 4.31535C16.2787 4.30674 16.2872 4.29831 16.2957 4.29006L19.4853 1.10051C19.8758 0.709986 20.509 0.709986 20.8995 1.10051C21.29 1.49103 21.29 2.1242 20.8995 2.51472L18.496 4.91819ZM12.9541 4.23241C12.3077 4.07881 11.6544 4.00001 11 4.00001C6.55237 4.00001 2 8.08788 2 11C2 11.7266 2.3851 12.7108 3.09762 13.7134C3.41756 14.1635 3.31198 14.7878 2.86181 15.1078C2.41163 15.4277 1.78733 15.3221 1.46739 14.872C0.533766 13.5583 0 12.1941 0 11C0 6.93246 5.49292 2.00001 11 2.00001C11.8125 2.00001 12.6207 2.09751 13.4164 2.28659C13.9538 2.41427 14.2858 2.95337 14.1582 3.49069C14.0305 4.02801 13.4914 4.36009 12.9541 4.23241Z"
                fill="#797A81"
              />
            </svg>

            <svg
              *ngIf="hide1"
              width="22"
              height="18"
              viewBox="0 0 22 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 18C5.49292 18 0 13.0675 0 9C0 4.93246 5.49292 0 11 0C16.5071 0 22 4.93246 22 9C22 13.0675 16.5071 18 11 18ZM11 16C15.4476 16 20 11.9121 20 9C20 6.08788 15.4476 2 11 2C6.55237 2 2 6.08788 2 9C2 11.9121 6.55237 16 11 16ZM11 13.5C8.51472 13.5 6.5 11.4853 6.5 9C6.5 6.51472 8.51472 4.5 11 4.5C13.4853 4.5 15.5 6.51472 15.5 9C15.5 11.4853 13.4853 13.5 11 13.5ZM11 11.5C12.3807 11.5 13.5 10.3807 13.5 9C13.5 7.61929 12.3807 6.5 11 6.5C9.61929 6.5 8.5 7.61929 8.5 9C8.5 10.3807 9.61929 11.5 11 11.5Z"
                fill="#797A81"
              />
            </svg>
          </button>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div
        class="col-12 col-sm-6 col-lg-4"
        (click)="setUsernameToReadOnlyFalse()"
      >
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label [ngStyle]="getLabelStyle()">New Password</mat-label>
          <input
            formControlName="newpassword"
            (change)="errorMessage = ''"
            [type]="hide2 ? 'text' : 'password'"
            matInput
            maxlength="50"
            placeholder=""
            name="oldpassword"
            (keyup)="inputChanged($event)"
            [readonly]="isUsernameReadOnly"
            [style.color]="createProfile.get('newpassword')?.invalid && (createProfile.get('newpassword')?.dirty && createProfile.get('newpassword')?.touched) ? 'rgba(204, 0, 0, 1)!important' : ''"
            (input)="errorMessage = ''"
          />

          <button
            matSuffix
            (click)="hide2 = !hide2"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide2"
            type="button"
            mat-icon-button
          >
            <svg
              *ngIf="!hide2"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="rgba(204, 0, 0, 1)"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0862 13.328C10.3725 13.4404 10.6812 13.5 11 13.5C12.3807 13.5 13.5 12.3807 13.5 11C13.5 10.6812 13.4404 10.3725 13.328 10.0862L10.0862 13.328ZM14.81 8.60425C15.2551 9.31096 15.5 10.1367 15.5 11C15.5 13.4853 13.4853 15.5 11 15.5C10.1367 15.5 9.31096 15.2551 8.60425 14.81L6.60263 16.8116C7.98547 17.5773 9.48878 18 11 18C15.4476 18 20 13.9121 20 11C20 9.7008 18.8434 7.80659 17.0764 6.33781L14.81 8.60425ZM18.496 4.91819C20.6046 6.71959 22 9.0733 22 11C22 15.0675 16.5071 20 11 20C8.94776 20 6.93674 19.3774 5.14077 18.2734L2.51472 20.8995C2.12419 21.29 1.49103 21.29 1.10051 20.8995C0.709981 20.509 0.709981 19.8758 1.10051 19.4853L4.29174 16.2941C4.30004 16.2855 4.30847 16.277 4.31702 16.2688L16.2704 4.31535C16.2787 4.30674 16.2872 4.29831 16.2957 4.29006L19.4853 1.10051C19.8758 0.709986 20.509 0.709986 20.8995 1.10051C21.29 1.49103 21.29 2.1242 20.8995 2.51472L18.496 4.91819ZM12.9541 4.23241C12.3077 4.07881 11.6544 4.00001 11 4.00001C6.55237 4.00001 2 8.08788 2 11C2 11.7266 2.3851 12.7108 3.09762 13.7134C3.41756 14.1635 3.31198 14.7878 2.86181 15.1078C2.41163 15.4277 1.78733 15.3221 1.46739 14.872C0.533766 13.5583 0 12.1941 0 11C0 6.93246 5.49292 2.00001 11 2.00001C11.8125 2.00001 12.6207 2.09751 13.4164 2.28659C13.9538 2.41427 14.2858 2.95337 14.1582 3.49069C14.0305 4.02801 13.4914 4.36009 12.9541 4.23241Z"
                [style.fill]="createProfile.get('newpassword')?.invalid && (createProfile.get('newpassword')?.dirty && createProfile.get('newpassword')?.touched) ? 'rgba(204, 0, 0, 1)' : '#797A81'"
              />
            </svg>

            <svg
              *ngIf="hide2"
              width="22"
              height="18"
              viewBox="0 0 22 18"
              fill="rgba(204, 0, 0, 1)"
              xmlns="http://www.w3.org/2000/svg"

            >
              <path
                d="M11 18C5.49292 18 0 13.0675 0 9C0 4.93246 5.49292 0 11 0C16.5071 0 22 4.93246 22 9C22 13.0675 16.5071 18 11 18ZM11 16C15.4476 16 20 11.9121 20 9C20 6.08788 15.4476 2 11 2C6.55237 2 2 6.08788 2 9C2 11.9121 6.55237 16 11 16ZM11 13.5C8.51472 13.5 6.5 11.4853 6.5 9C6.5 6.51472 8.51472 4.5 11 4.5C13.4853 4.5 15.5 6.51472 15.5 9C15.5 11.4853 13.4853 13.5 11 13.5ZM11 11.5C12.3807 11.5 13.5 10.3807 13.5 9C13.5 7.61929 12.3807 6.5 11 6.5C9.61929 6.5 8.5 7.61929 8.5 9C8.5 10.3807 9.61929 11.5 11 11.5Z"
                [style.fill]="createProfile.get('newpassword')?.invalid && (createProfile.get('newpassword')?.dirty && createProfile.get('newpassword')?.touched) ? 'rgba(204, 0, 0, 1)' : '#797A81'"
              />
            </svg>
          </button>
        </mat-form-field>
        <div
          class="error-message-block mt-24"
          *ngIf="
            createProfile.get('newpassword')?.hasError('mismatch') ||
            createProfile.get('confirm')?.hasError('mismatch')
          "
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 15C10.2833 15 10.521 14.904 10.713 14.712C10.9043 14.5207 11 14.2833 11 14C11 13.7167 10.9043 13.479 10.713 13.287C10.521 13.0957 10.2833 13 10 13C9.71667 13 9.47933 13.0957 9.288 13.287C9.096 13.479 9 13.7167 9 14C9 14.2833 9.096 14.5207 9.288 14.712C9.47933 14.904 9.71667 15 10 15ZM9 11H11V5H9V11ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
              fill="#870004"
            />
          </svg>
          <span class="field-required-font">Passwords do not match.</span>
        </div>
        <div
          class="error-message-block"
          *ngIf="createProfile?.errors?.matchPasswords || errorMessage"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 15C10.2833 15 10.521 14.904 10.713 14.712C10.9043 14.5207 11 14.2833 11 14C11 13.7167 10.9043 13.479 10.713 13.287C10.521 13.0957 10.2833 13 10 13C9.71667 13 9.47933 13.0957 9.288 13.287C9.096 13.479 9 13.7167 9 14C9 14.2833 9.096 14.5207 9.288 14.712C9.47933 14.904 9.71667 15 10 15ZM9 11H11V5H9V11ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
              fill="#870004"
            />
          </svg>
          <span class="field-required-font">{{ errorMessage || "Password do not match" }}</span>
        </div>
      </div>
      <div
        class="col-12 col-sm-6 col-lg-4"
        (click)="setUsernameToReadOnlyFalse()"
      >
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label [ngStyle]="getLabelStyle()">Retype Password</mat-label>
          <input
            formControlName="confirm"
            [type]="hide3 ? 'text' : 'password'"
            matInput
            placeholder=""
            name="oldpassword"
            (keyup)="inputChanged($event)"
            [readonly]="isUsernameReadOnly"
            [style.color]="createProfile.get('confirm')?.invalid && (createProfile.get('confirm')?.dirty && createProfile.get('confirm')?.touched) ? 'rgba(204, 0, 0, 1)!important' : ''"
            (input)="errorMessage = ''"
            maxlength="50"
          />
          <!-- <mat-error *ngIf="hasMismatchError()">
          </mat-error> -->
          <button
            matSuffix
            (click)="hide3 = !hide3"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide3"
            type="button"
            mat-icon-button
          >
            <svg
              *ngIf="!hide3"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.0862 13.328C10.3725 13.4404 10.6812 13.5 11 13.5C12.3807 13.5 13.5 12.3807 13.5 11C13.5 10.6812 13.4404 10.3725 13.328 10.0862L10.0862 13.328ZM14.81 8.60425C15.2551 9.31096 15.5 10.1367 15.5 11C15.5 13.4853 13.4853 15.5 11 15.5C10.1367 15.5 9.31096 15.2551 8.60425 14.81L6.60263 16.8116C7.98547 17.5773 9.48878 18 11 18C15.4476 18 20 13.9121 20 11C20 9.7008 18.8434 7.80659 17.0764 6.33781L14.81 8.60425ZM18.496 4.91819C20.6046 6.71959 22 9.0733 22 11C22 15.0675 16.5071 20 11 20C8.94776 20 6.93674 19.3774 5.14077 18.2734L2.51472 20.8995C2.12419 21.29 1.49103 21.29 1.10051 20.8995C0.709981 20.509 0.709981 19.8758 1.10051 19.4853L4.29174 16.2941C4.30004 16.2855 4.30847 16.277 4.31702 16.2688L16.2704 4.31535C16.2787 4.30674 16.2872 4.29831 16.2957 4.29006L19.4853 1.10051C19.8758 0.709986 20.509 0.709986 20.8995 1.10051C21.29 1.49103 21.29 2.1242 20.8995 2.51472L18.496 4.91819ZM12.9541 4.23241C12.3077 4.07881 11.6544 4.00001 11 4.00001C6.55237 4.00001 2 8.08788 2 11C2 11.7266 2.3851 12.7108 3.09762 13.7134C3.41756 14.1635 3.31198 14.7878 2.86181 15.1078C2.41163 15.4277 1.78733 15.3221 1.46739 14.872C0.533766 13.5583 0 12.1941 0 11C0 6.93246 5.49292 2.00001 11 2.00001C11.8125 2.00001 12.6207 2.09751 13.4164 2.28659C13.9538 2.41427 14.2858 2.95337 14.1582 3.49069C14.0305 4.02801 13.4914 4.36009 12.9541 4.23241Z"
                [style.fill]="createProfile.get('confirm')?.invalid && (createProfile.get('confirm')?.dirty && createProfile.get('confirm')?.touched) ? 'rgba(204, 0, 0, 1)' : '#797A81'"
              />
            </svg>

            <svg
              *ngIf="hide3"
              width="22"
              height="18"
              viewBox="0 0 22 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 18C5.49292 18 0 13.0675 0 9C0 4.93246 5.49292 0 11 0C16.5071 0 22 4.93246 22 9C22 13.0675 16.5071 18 11 18ZM11 16C15.4476 16 20 11.9121 20 9C20 6.08788 15.4476 2 11 2C6.55237 2 2 6.08788 2 9C2 11.9121 6.55237 16 11 16ZM11 13.5C8.51472 13.5 6.5 11.4853 6.5 9C6.5 6.51472 8.51472 4.5 11 4.5C13.4853 4.5 15.5 6.51472 15.5 9C15.5 11.4853 13.4853 13.5 11 13.5ZM11 11.5C12.3807 11.5 13.5 10.3807 13.5 9C13.5 7.61929 12.3807 6.5 11 6.5C9.61929 6.5 8.5 7.61929 8.5 9C8.5 10.3807 9.61929 11.5 11 11.5Z"
                [style.fill]="createProfile.get('confirm')?.invalid && (createProfile.get('confirm')?.dirty && createProfile.get('confirm')?.touched) ? 'rgba(204, 0, 0, 1)' : '#797A81'"
              />
            </svg>
          </button>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="container-fluid" *ngIf="loading">
    <div class="row">
      <div class="col-12 col-sm-4 mb-20">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ height: '40px', width: '350px', 'border-radius': '3px' }"
        >
        </ngx-skeleton-loader>
      </div>
      <div class="col-12 col-sm-4 mb-20">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ height: '40px', width: '350px', 'border-radius': '3px' }"
        >
        </ngx-skeleton-loader>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-4 mb-20">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ height: '40px', width: '350px', 'border-radius': '3px' }"
        >
        </ngx-skeleton-loader>
      </div>
      <div class="col-12 col-sm-4 mb-20">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ height: '40px', width: '350px', 'border-radius': '3px' }"
        >
        </ngx-skeleton-loader>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-4 mb-20">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ height: '40px', width: '350px', 'border-radius': '3px' }"
        >
        </ngx-skeleton-loader>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-20">
        <div class="secondary-label">
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{ height: '15px', width: '350px', 'border-radius': '3px' }"
          >
          </ngx-skeleton-loader>
        </div>
      </div>
      <div class="col-12 mb-20">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ height: '40px', width: '350px', 'border-radius': '3px' }"
        >
        </ngx-skeleton-loader>
      </div>
      <div class="col-12 col-sm-4 mb-20">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ height: '40px', width: '350px', 'border-radius': '3px' }"
        >
        </ngx-skeleton-loader>
      </div>
      <div class="col-12 col-sm-4 mb-20">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{ height: '40px', width: '350px', 'border-radius': '3px' }"
        >
        </ngx-skeleton-loader>
      </div>
    </div>
  </div>
</form>
